import { render, staticRenderFns } from "./Yasu5.vue?vue&type=template&id=45376ce1&scoped=true"
import script from "./Yasu5.vue?vue&type=script&lang=js"
export * from "./Yasu5.vue?vue&type=script&lang=js"
import style0 from "./Yasu5.vue?vue&type=style&index=0&id=45376ce1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45376ce1",
  null
  
)

export default component.exports